import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Flex } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { isResponsiveProp } from "@faire/web--source/slate/Theme/ResponsiveProp";
import React from "react";
import styled, { css } from "styled-components";
import { showroomVettingCriteriaInfo, VETTING_CRITERIA } from "@faire/retailer/features/Showroom/ShowroomVettingCriteria/ShowroomVettingCriteriaInfo";
import { SingleShowroomVettingCriteria } from "@faire/retailer/features/Showroom/ShowroomVettingCriteria/SingleShowroomVettingCriteria";
export var ShowroomVettingCriteria = function(param) {
    var className = param.className, column = param.column, gap = param.gap, verticalPadding = param.verticalPadding, border = param.border, align = param.align, alignText = param.alignText, borderColor = param.borderColor, color = param.color, showDescriptionText = param.showDescriptionText, titleTypographyVariants = param.titleTypographyVariants, _param_vettingCriteriaList = param.vettingCriteriaList, vettingCriteriaList = _param_vettingCriteriaList === void 0 ? [
        VETTING_CRITERIA.QUALITY_FABRICS,
        VETTING_CRITERIA.PRECISE_FIT,
        VETTING_CRITERIA.THOUGHTFUL_CONSTRUCTION
    ] : _param_vettingCriteriaList;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var vettingCriteria = showroomVettingCriteriaInfo(color !== null && color !== void 0 ? color : Core.text.enabled, showDescriptionText, titleTypographyVariants, strictLocalize);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: vettingCriteriaList.map(function(criteriaItem, index) {
            return /*#__PURE__*/ _jsx(FlexWithCustomDirection, {
                className: className,
                $column: column,
                $gap: gap,
                $verticalPadding: verticalPadding,
                $border: border ? index !== 0 : false,
                align: align,
                $borderColor: borderColor,
                children: /*#__PURE__*/ _jsx(SingleShowroomVettingCriteria, _object_spread_props(_object_spread({}, vettingCriteria[criteriaItem]), {
                    alignText: alignText
                }))
            }, "".concat(vettingCriteria, "_").concat(index));
        })
    });
};
// eslint-disable-next-line @faire/prefer-slate-attrs -- move direction and align to props
var FlexWithCustomDirection = styled(Flex).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-f23c3505-0"
})([
    "&&&{flex-direction:",
    ";align-items:",
    ";",
    ";",
    "}"
], function(props) {
    return props.$column ? "column" : "row";
}, function(props) {
    var _props_align;
    return (_props_align = props.align) !== null && _props_align !== void 0 ? _props_align : "center";
}, function(props) {
    var _props_$borderColor;
    return props.$border ? css([
        "border-left:1px solid ",
        ";"
    ], (_props_$borderColor = props.$borderColor) !== null && _props_$borderColor !== void 0 ? _props_$borderColor : Core.border.muted) : "";
}, function(param) {
    var _param_$gap = param.$gap, $gap = _param_$gap === void 0 ? 0 : _param_$gap, tmp = param.$verticalPadding, verticalPadding = tmp === void 0 ? 0 : tmp;
    var horizontalGap = isResponsiveProp($gap) ? $gap : {
        mobileAndAbove: $gap
    };
    var verticalGap = isResponsiveProp(verticalPadding) ? verticalPadding : {
        mobileAndAbove: verticalPadding
    };
    var _verticalGap_tabletAndAbove, _horizontalGap_tabletAndAbove, _verticalGap_desktopAndAbove, _ref, _horizontalGap_desktopAndAbove, _ref1, _verticalGap_xLargeAndAbove, _ref2, _ref3, _horizontalGap_xLargeAndAbove, _ref4, _ref5;
    return css([
        "padding:",
        ";",
        "{padding:",
        ";}",
        "{padding:",
        ";}",
        "{padding:",
        ";}"
    ], getSpacing(verticalGap.mobileAndAbove, horizontalGap.mobileAndAbove), responsiveMediaQueries.tabletAndAbove, getSpacing((_verticalGap_tabletAndAbove = verticalGap.tabletAndAbove) !== null && _verticalGap_tabletAndAbove !== void 0 ? _verticalGap_tabletAndAbove : verticalGap.mobileAndAbove, (_horizontalGap_tabletAndAbove = horizontalGap.tabletAndAbove) !== null && _horizontalGap_tabletAndAbove !== void 0 ? _horizontalGap_tabletAndAbove : horizontalGap.mobileAndAbove), responsiveMediaQueries.desktopAndAbove, getSpacing((_ref = (_verticalGap_desktopAndAbove = verticalGap.desktopAndAbove) !== null && _verticalGap_desktopAndAbove !== void 0 ? _verticalGap_desktopAndAbove : verticalGap.tabletAndAbove) !== null && _ref !== void 0 ? _ref : verticalGap.mobileAndAbove, (_ref1 = (_horizontalGap_desktopAndAbove = horizontalGap.desktopAndAbove) !== null && _horizontalGap_desktopAndAbove !== void 0 ? _horizontalGap_desktopAndAbove : horizontalGap.tabletAndAbove) !== null && _ref1 !== void 0 ? _ref1 : horizontalGap.mobileAndAbove), responsiveMediaQueries.xLargeAndAbove, getSpacing((_ref3 = (_ref2 = (_verticalGap_xLargeAndAbove = verticalGap.xLargeAndAbove) !== null && _verticalGap_xLargeAndAbove !== void 0 ? _verticalGap_xLargeAndAbove : verticalGap.desktopAndAbove) !== null && _ref2 !== void 0 ? _ref2 : verticalGap.tabletAndAbove) !== null && _ref3 !== void 0 ? _ref3 : verticalGap.mobileAndAbove, (_ref5 = (_ref4 = (_horizontalGap_xLargeAndAbove = horizontalGap.xLargeAndAbove) !== null && _horizontalGap_xLargeAndAbove !== void 0 ? _horizontalGap_xLargeAndAbove : horizontalGap.desktopAndAbove) !== null && _ref4 !== void 0 ? _ref4 : horizontalGap.tabletAndAbove) !== null && _ref5 !== void 0 ? _ref5 : horizontalGap.mobileAndAbove));
});
